import { graphql } from '@/__generated__';
import { useCacheMonitor } from '@/context/DiscoveryUrqlProvider';
import { useLazyQuery } from '../useLazyQuery';
import { useQueryStable } from '../useQueryStable';
import { discoveryLineageResourceTypes } from './appliedLineage';

export const GetAllViewBy = graphql(/* GraphQL */ `
  query AppliedViewBy(
    $environmentId: BigInt!
    $userId: BigInt
    $types: [ResourceNodeType!]!
  ) {
    environment(id: $environmentId, userId: $userId) {
      dbtProjectName
      applied {
        lastUpdatedAt
        lineage(filter: { types: $types }) {
          uniqueId
          name
          database
          schema
          filePath
          tags
        }
      }
    }
  }
`);

type AppliedViewByParams = {
  environmentId: number | undefined;
  userId: number | 'loading' | null;
  pause?: boolean;
};

export const useAllAppliedViewBy = ({
  environmentId = 0,
  userId = -1,
  pause,
}: AppliedViewByParams) => {
  const query = useQueryStable({
    query: GetAllViewBy,
    variables: {
      environmentId,
      userId: userId as number | null,
      types: discoveryLineageResourceTypes,
    },
    pause: pause || !environmentId,
  });

  useCacheMonitor({ applied: query[0].data?.environment.applied?.lastUpdatedAt });

  return query;
};

export const useAllAppliedViewByLazy = () => {
  return useLazyQuery(GetAllViewBy);
};
